import React from "react";

export const PrevIcon = () =>{
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 38 38" fill="none">
      <g filter="url(#filter0_d_241_43160)">
        <circle cx="15" cy="15" r="15" transform="matrix(1 0 0 -1 4 30)" fill="#D9D9D9" fill-opacity="0.65" shape-rendering="crispEdges"/>
      </g>
      <g filter="url(#filter1_d_241_43160)">
        <path d="M22 23L14 15.5L22 8" stroke="#F07326" stroke-width="2.58466" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
        <filter id="filter0_d_241_43160" x="0" y="0" width="38" height="38" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_241_43160"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_241_43160" result="shape"/>
        </filter>
        <filter id="filter1_d_241_43160" x="8.70767" y="6.70764" width="18.5847" height="25.5847" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_241_43160"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_241_43160" result="shape"/>
        </filter>
      </defs>
    </svg>
  );
}

export const NextIcon = () =>{
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 38 38" fill="none">
      <g filter="url(#filter0_d_241_43161)">
        <circle cx="15" cy="15" r="15" transform="matrix(1 0 0 -1 4 30)" fill="#D9D9D9" fill-opacity="0.65" shape-rendering="crispEdges"/>
      </g>
      <g filter="url(#filter1_d_241_43161)">
        <path d="M16 23L24 15.5L16 8" stroke="#F07326" stroke-width="2.58466" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
        <filter id="filter0_d_241_43161" x="0" y="0" width="38" height="38" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_241_43161"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_241_43161" result="shape"/>
        </filter>
        <filter id="filter1_d_241_43161" x="10.7077" y="6.70764" width="18.5847" height="25.5847" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_241_43161"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_241_43161" result="shape"/>
        </filter>
      </defs>
    </svg>
  );
}